import { SetStyles, Scale, AddMouseDownListener } from "./MyHelpers";
import { ImageResource } from "./ResourceManager/ImageResource";
import { Resourceful } from "./ResourceManager/Resourceful";
import { ResourceIdentifier } from "./ResourceManager/ResourceIdentifier";
import { IReadOnlyResourceManager, IWriteOnlyResourceManager, ResourceManager } from "./ResourceManager/ResourceManager";
import { service } from "./services";
import { Settings } from "./Settings";
import { Translator, Translation, AvailableLanguage } from "./Translator";

export class TranslatorView implements Resourceful
{
    protected view:HTMLElement = null;
    // protected availableLanguages: AvailableLanguage[] = [];
    private resid: ResourceIdentifier = null;

    protected flags:Map<string, ImageResource> = new Map<string,ImageResource>();

    protected path: string = Settings.ResourcesFolder + "multigame/multigame/Language/";

    

    constructor(resid: ResourceIdentifier)
    {
        this.resid = resid.Add("languageView");
        service.translator.SetOnLanguageChangedCallback((t: Translation) => this.OnLanguageChanged(t));
    }

    public async PrepareResources(resourceManager: IWriteOnlyResourceManager): Promise<void>
    {
        let availableLanguages = service.translator.AvailableLanguages();
        for(let i = 0; i < availableLanguages.length; i++)
        {
            let flag:ImageResource = new ImageResource(this.path + availableLanguages[i].nameEnglish+".png", this.resid.ScopedResourceName(["language", availableLanguages[i].nameEnglish]));
            resourceManager.Add(flag);
            this.flags.set(availableLanguages[i].locality,flag);
        }
        
    }

    public ResourcesLoaded(resourceManager: IReadOnlyResourceManager)
    {
        this.view = document.createElement("div");
        this.view.classList.add(this.resid.Scope());
        this.view.classList.add("language");



        SetStyles(this.view,
        {
            //position:"absolute",
            //right: Scale.Xpx(25),
            width: "100%",
            height: "100%",
            backgroundImage: resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["language", service.translator.t.languageEnglish])).CssBackground(),
            backgroundSize: "contain",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center"
        });

        

        AddMouseDownListener(this.view, () => 
        {
            service.translator.NextLanguage();
        });

    }

    protected OnLanguageChanged(t: Translation):void
    {

        if (this.view)
        {
            this.view.style.backgroundImage = this.flags.get(t.locality).CssBackground();
        }
    }

    public View():HTMLElement
    {
        return this.view;
    }
}